











import Vue from 'vue'

export default Vue.component('loader', {
  props: {
    timeout: { type: Number, required: false },
    message: { type: String, required: false }
  },

  data () {
    return {
      show: true
    }
  },

  mounted () {
    if (this.timeout) {
      setTimeout(() => {
        this.show = false
      }, this.timeout);
    }
  }
})
